import Axios from "axios";
import React, { useState,useEffect } from "react";
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "../api";
// import { server } from "./server";
import "./RazorPay.css"

function App() {
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const params =useParams()
  const navigate = useNavigate()
  var token =localStorage.getItem("token")
  const [requestamount, setRequestAmount] = useState('');

  useEffect(() => {
    fetch(`${BASE_URL}core/requested_amount/`)
      .then(response => response.json())
      .then(data => setRequestAmount(data.data))
      .catch(error => console.error(error));
  }, []);
  console.log(requestamount)

// this function will handel payment when user submit his/her money
// and it will confim if payment is successfull or not
  const handlePaymentSuccess = async (response) => {
      let bodyData = new FormData();
      console.log(response);
      // we will send the response we've got from razorpay to the backend to validate the payment
      bodyData.append("response", JSON.stringify(response));
      console.log(token);
  }
      // await Axios({
      //   url: `${BASE_URL}payments/payment_confirm/`,
      //   method: "POST",
      //   data: bodyData,
      //   headers: {
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //     Authorization: `Token ${token}`
      //     // Authorization: "Token 20efffc5a3d75f5179f63f7cc5e1e665e13b3dc2"
      //   },
      // })
  //       .then((res) => {
  //         console.log("Everything is OK!");
  //         setName("");
  //         setAmount("");
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   } catch (error) {
  //     console.log(console.error());
  //   }
  // };

  // this will load a script tag which will open up Razorpay payment card to make //transactions
  // const loadScript = () => {
  //   const script = document.createElement("script");
  //   script.src = "https://checkout.razorpay.com/v1/checkout.js";
  //   document.body.appendChild(script);
  // };

  // const showRazorpay = async () => {
  //   const res = await loadScript();

  //   let bodyData = new FormData();

  //   // we will pass the amount and product name to the backend using form data
  //   bodyData.append("amount", amount.toString());
  //   bodyData.append("name", name);
  //   console.log(amount, name)
   
  //   console.log(params);
  //   const data = await Axios({
      
  //     url: `${BASE_URL}payments/handle_payment/`,
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
      

  //       Authorization: `Token ${token}`,
  //       // Authorization: "Token 20efffc5a3d75f5179f63f7cc5e1e665e13b3dc2"
  //     },
  //     data: {
  //       "amount": `${requestamount.amount}`,
  //       student_id: params?.id,
  //       // "student_id": 258,
  //       "currency": "INR"
  //     },
    
  //   }).then((res) => {
  //     return res;
  //   });

  //   console.log(data);
  //   // in data we will receive an object from the backend with the information about the payment
  //   //that has been made by the user

  //   var options = {
  //     key_id: "rzp_test_7ykX4wdaUZ7lhm", // in react your environment variable must start with REACT_APP_
  //     key_secret: "4puxKObzME42FFWJRImVwVby",
  //     amount:requestamount.amount,
  //     currency: "INR",
  //     name: "ISBC",
  //     description: "Test teansaction",
  //     image: "../../assests/logo.jpeg", // add image url
  //     order_id: data.data.data.order_id,
  //     handler: function (response) {
  //       // we will handle success by calling handlePaymentSuccess method and
  //       // will pass the response that we've got from razorpay
  //       console.log(response);
  //       handlePaymentSuccess(response);
  //       navigate("/registered-players")
  //     },
  //     prefill: {
  //       name: "User's name",
  //       email: "User's email",
  //       contact: "User's phone",
  //     },
  //     notes: {
  //       address: "Razorpay Corporate Office",
  //     },
  //     theme: {
  //       color: "#3399cc",
  //     },
  //   };

  //   var rzp1 = new window.Razorpay(options);
  //   rzp1.open();
  // };

  return (
    <div className="container-payment">
      <div className="rzp-container-2">
      <div className="PaymentText-rzp">
     
        <h5>Please proceed to make a payment of "Rs:50" to complete your enrollment.</h5>
        {/* <h5>You're one step away from being enrolled! Please complete your payment to finish the process.</h5> */}
        </div>
     
        <div className="rzp-btn-payNow">
   
      <button onClick={handlePaymentSuccess} className='profile-preview-payment-btn'>
        Pay Now
      </button>
      </div>
      </div>
    </div>
  );
}

export default App;